import {
    Avatar,
    Box,
    Button,
    Divider,
    HStack,
    Text,
    Textarea,
    useToast,
    VStack,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FaNotesMedical } from 'react-icons/fa';
import { addFacilityNote, deleteFacilityNote } from '../../api'; // adjust path if needed
import AccessDenied from '../../components/AccessDenied';
import { useTableColors } from '../../Utils';

const FacilityAddNotes = ({ facility, setSelectedItem, doSet = false }) => {
    const [newNote, setNewNote] = useState('');
    const [loading, setLoading] = useState(false);
    const [notes, setNotes] = useState(facility.notes || []);
    const toast = useToast();
    const coolors = useTableColors()

    const handleAddNote = async () => {
        if (!newNote.trim()) return;
        setLoading(true);
        try {
            const res = await addFacilityNote(facility._id, newNote);
            if (res.success) {
                toast({
                    title: 'Note added successfully.',
                    status: 'success',
                    duration: 3000,
                    position: 'top-right',
                    isClosable: true,
                });
                setNewNote('');

                setNotes(prev => [
                    ...prev,
                    {
                        _id: res.data.at(-1)._id,
                        content: newNote,
                        createdAt: new Date().toISOString(),
                        addedBy: { firstName: 'You', lastName: '' }, // Replace with real user
                    }
                ]);

                if (doSet) {
                    setSelectedItem(prev => ({
                        ...prev,
                        notes: [...(prev.notes || []), {
                            content: newNote,
                            createdAt: new Date().toISOString(),
                            addedBy: { _id: '1', firstName: "You", lastName: "" }, // pull from auth
                            _id: res.data.at(-1)._id // or whatever was returned
                        }]
                    }));
                }

            } else {
                toast({
                    title: res.error,
                    status: 'error',
                    duration: 3000,
                    position: 'top-right',
                    isClosable: true,
                });
            }
        } catch (e) {
            toast({
                title: e.message,
                status: 'error',
                duration: 3000,
                position: 'top-right',
                isClosable: true,
            });
        }
        setLoading(false);
    };


    const handleDeleteNote = async (noteId) => {
        setLoading(true);
        try {
            await deleteFacilityNote(facility._id, noteId);
            setNotes(prev => prev.filter(n => n._id !== noteId));
            if (doSet) {
                setSelectedItem(prev => ({
                    ...prev,
                    notes: prev.notes.filter(n => n._id !== noteId)
                }));
            }
        } catch {
            toast({ title: 'Error deleting note.', status: 'error' });
        }
        setLoading(false);
    };

    if (!facility) return null;
    return (
        <Box>
            <VStack align="stretch" spacing={4}>
                {notes.length ? (
                    notes.map((note) => (
                        <Box key={note._id} borderWidth="1px" borderRadius="md" bg={coolors.theadBg} p={3}>
                            <HStack justifyContent="space-between">
                                <HStack>
                                    <Avatar size="sm" name={note.addedBy?.firstName} />
                                    <Text fontWeight="bold">
                                        {note.addedBy?.firstName} {note.addedBy?.lastName}
                                    </Text>
                                </HStack>
                                <Button
                                    size="xs"
                                    colorScheme="red"
                                    variant="outline"
                                    onClick={() => handleDeleteNote(note._id)}
                                    isLoading={loading}
                                >
                                    Delete
                                </Button>
                            </HStack>
                            <Text mt={2}>{note.content}</Text>
                            <Text fontSize="xs" color="gray.500" mt={1}>
                                {new Date(note.createdAt).toLocaleString()}
                            </Text>
                        </Box>
                    ))
                ) : (
                    <AccessDenied msg="No Notes on this facility" icon={<FaNotesMedical size={64} />} />
                )}
            </VStack>

            <Divider my={4} />

            <Box>
                <Text mb={2} fontWeight="semibold">Add Note</Text>
                <Textarea
                    value={newNote}
                    resize={false}
                    onChange={(e) => setNewNote(e.target.value)}
                    placeholder="Enter your note here..."
                />
                <Button
                    mt={3}
                    colorScheme="blue"
                    onClick={handleAddNote}
                    isLoading={loading}
                    size={"xs"}
                >
                    Add Note
                </Button>
            </Box>
        </Box>
    );
};

export default FacilityAddNotes;
